import { string } from 'yup';

const formUtil = {
  schema: {
    prefix: string().oneOf(['MR.', 'MS.', 'MRS.', 'MISS']).required(),
    nationality: string().oneOf(['cambodia', 'laos', 'myanmar', 'vietnam', 'indonesia', 'malaysia']).required(),
    idCardType: string().oneOf(['pid', 'wpid', 'cid', 'otherwp']).required(),
  },
  option: {
    prefix: [
      { value: 'MR.', label: 'MR.' },
      { value: 'MRS.', label: 'MRS.' },
      { value: 'MS.', label: 'MS.' },
      { value: 'MISS', label: 'MISS' },
    ],
    pkg: [
      { value: '3m', label: '3 เดือน (750 บาท)' },
      { value: '6m', label: '6 เดือน (990 บาท)' },
      { value: '1y', label: '1 ปี (1790 บาท)' },
      { value: '15m', label: '15 เดือน (2475 บาท)' },
    ],
    nation: [
      { value: 'cambodia', label: 'Cambodia' },
      { value: 'laos', label: 'Laos' },
      { value: 'myanmar', label: 'Myanmar' },
      { value: 'vietnam', label: 'Vietnam' },
      { value: 'indonesia', label: 'Indonesia' },
      { value: 'malaysia', label: 'Malaysia' },
    ],
    cardtype: [
      { value: 'pid', label: 'เลขที่พาสปอร์ต' },
      { value: 'wpid', label: 'เลขที่ Work Permit' },
      { value: 'cid', label: 'เลขที่ CI No / TD No.' },
      { value: 'otherwp', label: 'เลขที่ใบแทนอนุญาตทำงาน (บต.23, 39, 48)' },
    ],
  },
};

export default formUtil;
